module.exports = __webpack_public_path__ + "img/gbwhatsapp-site-pic.c3f91395.webp";